import axios from 'axios';
import * as Interceptors from '../interceptors';
import rebrand from '../../../config/rebrand';

const API_ENDPOINT = rebrand.urls.API_ENDPOINT;

let instance;

export default () => {
  if (instance) {
    return instance;
  }

  const LoaderResponse = Interceptors.loader.response;

  instance = axios.create(
    { baseURL: API_ENDPOINT }
  );

  instance.interceptors.request.use(Interceptors.loader.request);

  instance.interceptors.response.use(response => response, Interceptors.token(instance));
  instance.interceptors.response.use(LoaderResponse.success, LoaderResponse.error);

  return instance;
};



/** WEBPACK FOOTER **
 ** ./src/helpers/request/api/instance.js
 **/